/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { InputAdornment, Snackbar, SnackbarContent, TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import { partNumberSearchEndpoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';

interface Props {
    handlePartNumberSearch: Function,
    classes?: any,
    isLoading: any,
    LoadPartNumber: Function
    partNumber: any
    UpdatepartNumber: Function
    Updatesearchstatus: Function
    StopLoading: Function
    ClearAll: Function
}
const styles = () => ({
    input: {
        backgroundColor: '#fff',
        height: 48,
        width: 312
    },
    root: {
        justifyContent: 'center'
    }
});

class PartNumberSearch extends React.Component<Props, {}> {
    state = {
        selectedindex: 0,
        validationError: ''
    };
    handleChange = (event: any) => {
        this.props.Updatesearchstatus(false);
        this.props.ClearAll();
        this.props.UpdatepartNumber(event.target.value);
    };
    handlekeyPress = (event: any) => {
        if (event.key === 'Enter') {
            this.props.Updatesearchstatus(true);
            try {

                this.props.UpdatepartNumber(event.target.value);
                this.props.ClearAll();
                const token: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + token;
                const headerDict: any = {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const endpoint = partNumberSearchEndpoint;
                fetch(endpoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify({
                        'PartNumber': event.target.value
                    }),
                    method: 'POST'
                })
                    .then(async (response: any) => {
                        this.props.Updatesearchstatus(false);
                        switch (response.status) {
                            case 200: {
                                const data = await response.json();
                                this.props.StopLoading();
                                this.props.handlePartNumberSearch(data);
                            }
                                break;
                            case 400:
                                this.setState({ validationError: 'Please enter a minimum of 5 digits' });
                                this.props.StopLoading();
                                break;
                            case 404:
                                const data = await response.json();
                                this.props.StopLoading();
                                this.props.handlePartNumberSearch(data);
                                break;
                            default:
                                this.setState({ validationError: 'Product not found' });
                                this.props.StopLoading();
                        }
                    });
            }
            catch (e) { console.log(e); }
        }
    };

    handleClose = (value: any) => {
        this.props.StopLoading();
        this.setState({ selectedValue: value, open: false });
    };
    handleSnackBarClose = (event: any, reason: any) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ validationError: '' });
    };
    handleCheckboxChange = (index: any) => {
        this.setState({ selectedindex: index });
    };
    render() {
        const { classes, partNumber } = this.props;
        return (
            <div >
                <TextField
                    name="partNumber"
                    onChange={this.handleChange}
                    onKeyPress={this.handlekeyPress}
                    value={partNumber}
                    variant="outlined"
                    InputProps={{
                        className: classes.input, startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{ shrink: false }}
                    label={partNumber === '' ? 'Service part S/N' : ''}
                    className="partNumberinput"
                />
                <Snackbar
                    anchorOrigin={{
                        horizontal: 'left',
                        vertical: 'bottom'
                    }}
                    open={this.state.validationError !== ''}
                    autoHideDuration={5000}
                    onClose={this.handleSnackBarClose}
                >
                    <SnackbarContent
                        className="search-input-snackbar"
                        message={this.state.validationError}
                    />
                </Snackbar>
            </div>


        );
    }
}


export default
    ((withStyles(styles))(PartNumberSearch));

